import { OtherUserProfileCSS, Close } from './OtherUserProfileCSS.styled'
import { OtherUserPanel } from './OtherUserPanel'
import { OtherUserRedditPanel } from './OtherUserRedditPanel'
import { useUserPublicData } from 'hooks/user/useUserPublicData'
import { SingleContentToggle } from 'components/Atoms/SingleContentToggle'
import { useEffect, useMemo, useState } from 'react'
import { useLvgCloneBids } from 'hooks/games/lvg/useLvgCloneBids'
import { isEmpty } from 'lodash'
import { isAddressesEqual } from 'utils/wallet/addresses'
import { icons } from 'common'
import { currencyFormatter } from 'utils'

const followingToast = (username) => ({
  id: 'genericToast',
  props: {
    message: {
      icon: icons.clone_bid_icon,
      title: "You are now following and cloning this user's bids...",
      subtitle: username,
    },
  },
})

export const OtherUserProfileModal = ({ closeModal, address, username, avatar }) => {
  const { isPending, isError, userPublicData } = useUserPublicData(address)
  const [cloneToggle, setCloneToggle] = useState(false)
  const {
    getFollowee,
    isPending: isClonePending,
    followUser,
    unfollowUser,
    parentFeeRate,
    getParentFeeRate,
  } = useLvgCloneBids()

  const followee = useMemo(() => getFollowee(address), [getFollowee, address])
  const isFollowing = useMemo(
    () => isAddressesEqual(address, followee?.parentAddress),
    [address, followee?.parentAddress]
  )

  useEffect(() => {
    getParentFeeRate(address)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address])

  useEffect(() => {
    if (isFollowing) setCloneToggle(true)
    else setCloneToggle(false)
  }, [address, isFollowing])

  const clickStartCloning = (e) => {
    e.preventDefault()
    if (isFollowing) unfollowUser(address)
    else followUser(address, username)
  }

  const modalAvatar = avatar

  return (
    <OtherUserProfileCSS avatar={modalAvatar}>
      <div className='popUpContainer user-account other-user variable-width'>
        <article>
          <Close name='close2' masking onClick={closeModal} />

          <div className='profile_header'>
            <div className='profile_wrapper'>
              <div className='avatar_form other'>
                <input accept='image/*' type='file' id='select-image' style={{ display: 'none' }} />
                <label>
                  <div className='profile_avatar'></div>
                </label>
              </div>

              <div className='profile_name'>{username}</div>
            </div>
            <div className='clone_bids_wrapper'>
              <div className='clone_bids_main_wrapper'>
                <div class='title'>
                  Clone this user's bids
                  <div class='custom_fee_rate'>
                    Fee rate: <strong>{currencyFormatter(parentFeeRate / 100, { noCurrencySign: true })}%</strong>
                  </div>
                </div>

                <div className='bc_switch_wrapper' onClick={clickStartCloning}>
                  <input
                    className='toggle_switch_bc'
                    type='checkbox'
                    name='toggle_switch_bc'
                    id='toggle_switch_bc_object'
                    checked={cloneToggle}
                  />
                  <label htmlFor='toggle_switch_bc_object'></label>
                </div>
                <a
                  className='info_icon hint--rounded hint--medium hint--top'
                  data-hint='When you enable this feature, the platform will automatically clone every bid that this user places. You have the option to cash out when you want to, or let the bid cash out when the user does. In order to use this successfully, you must have enough funds in your Wallet for every bid placed.'
                ></a>
              </div>

              {/* <form>
                <label htmlFor='clone_bid_max-amount'>Max per cloned bid (required)</label>
                <fieldset disabled={isFollowing || !cloneToggle}>
                  <input
                    className='clone_bid_max-amount'
                    id='clone_bid_max-amount'
                    type='text'
                    placeholder='0.00'
                    value={maxAmount}
                    onChange={(e) => setMaxAMount(e.target.value)}
                  />
                  <button className='save' disabled={!maxAmount} onClick={clickStartCloning}>
                    Start cloning
                  </button>
                </fieldset>
              </form> */}
            </div>
          </div>
          <SingleContentToggle
            toggle={userPublicData.redditData}
            trueContent={<OtherUserRedditPanel userPublicData={userPublicData} isPending={isPending} />}
            falseContent={<OtherUserPanel userPublicData={userPublicData} isPending={isPending} />}
          />
        </article>
      </div>
    </OtherUserProfileCSS>
  )
}
